<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Error Tester</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content>
  <div class="alert alert-info" role="alert">
    <p class="m-0">Select a type of error to trigger:</p>
  </div>
  <div class="button-group mb-2">
    <button
      mat-raised-button
      color="primary"
      (click)="triggerError('manual')"
      matTooltip="Throws an error and manually captures it using Sentry.captureException().">
      <mat-icon>bug_report</mat-icon> Manual Error
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="triggerError('uncaught')"
      matTooltip="Throws an uncaught JavaScript error that Sentry captures via the global error handler.">
      <mat-icon>report_problem</mat-icon> Uncaught Error
    </button>
    <button
      mat-raised-button
      color="accent"
      (click)="triggerError('promise')"
      matTooltip="Triggers an unhandled Promise rejection — commonly missed if not caught.">
      <mat-icon>sync_problem</mat-icon> Promise Rejection
    </button>
    <button
      mat-raised-button
      color="warn"
      (click)="triggerError('http')"
      matTooltip="Performs a failing HTTP request and logs the resulting error to Sentry.">
      <mat-icon>cloud_off</mat-icon> HTTP Error
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="triggerError('custom')"
      matTooltip="Throws a custom error class to test how Sentry groups custom exception types.">
      <mat-icon>engineering</mat-icon> Custom Error
    </button>
    <button
      mat-raised-button
      color="secondary"
      (click)="triggerError('console')"
      matTooltip="Logs an error to the console — not captured by Sentry unless console integration is enabled.">
      <mat-icon>terminal</mat-icon> Console Error
    </button>
    <button
      mat-raised-button
      color="warn"
      matTooltip="Triggers a RuntimeException on the Laravel API"
      (click)="triggerError('api-runtime')">
      <mat-icon>report_problem</mat-icon> API Runtime Error
    </button>
    <button
      mat-raised-button
      color="accent"
      matTooltip="Triggers a validation error on the Laravel API"
      (click)="triggerError('api-validation')">
      <mat-icon>rule</mat-icon> API Validation Error
    </button>
    <button
      mat-raised-button
      color="warn"
      matTooltip="Triggers a DB query error on the Laravel API"
      (click)="triggerError('api-query')">
      <mat-icon>storage</mat-icon> API DB Query Error
    </button>
    <button
      mat-raised-button
      color="warn"
      matTooltip="Pushes a job to the queue that throws an exception on the Laravel API"
      (click)="triggerError('api-queue')">
      <mat-icon>schedule</mat-icon> API Queue Failure
    </button>
    <button
      mat-raised-button
      color="warn"
      matTooltip="Triggers an S3 file access error on the Laravel API"
      (click)="triggerError('api-s3')">
      <mat-icon>cloud_upload</mat-icon> API S3 Error
    </button>
    <button
      mat-raised-button
      color="primary"
      matTooltip="Throws a custom exception on the Laravel API"
      (click)="triggerError('api-custom')">
      <mat-icon>build</mat-icon> API Custom Error
    </button>
  </div>
</mat-dialog-content>
